import { useEffect, useState, type FC } from 'react';

import { SearchInput } from './SearchInput.js';
import { useDebouncedValue } from './useDebouncedValue.js';

/*
 * Поле поиска, которое отдаёт значение с задержкой. Набранное живёт локально, а
 * наружу (обычно в адресную строку) уходит отложенное: иначе каждый символ - и
 * запись в историю браузера, и запрос в API. Внешний сброс (навигация «назад»)
 * возвращается в поле.
 */

export interface DebouncedSearchInputProps {
  value: string;
  onCommit: (value: string) => void;
  placeholder?: string;
  'aria-label': string;
  className?: string;
  delayMs?: number;
}

export const DebouncedSearchInput: FC<DebouncedSearchInputProps> = ({
  value,
  onCommit,
  placeholder,
  'aria-label': ariaLabel,
  className,
  delayMs = 300,
}) => {
  const [draft, setDraft] = useState(value);
  const debounced = useDebouncedValue(draft, delayMs);

  useEffect(() => {
    if (debounced !== value) onCommit(debounced);
    // onCommit меняется на каждый рендер маршрута; следим только за значением.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounced]);

  useEffect(() => {
    setDraft((current) => (current === value ? current : value));
  }, [value]);

  return (
    <SearchInput
      className={className}
      placeholder={placeholder}
      aria-label={ariaLabel}
      value={draft}
      onChange={(event) => setDraft(event.target.value)}
    />
  );
};
